export default function getInputsValue(inputs) {
  const data = {}

  for (const key in inputs) {
    const obj = inputs[key]

    if (Array.isArray(obj)) {
      data[key] = obj.map(item => getInputsValue(item))
    } else {
      data[key] = getValue(obj)
    }
  }

  return data
}

function getValue(obj) {
  if(Array.isArray(obj.value)) {
    return obj.value.reduce((result, item) => {
      const hasId = item && item.hasOwnProperty('id')

      if(hasId && item.id === 'other') {
        return result
      }

      result.push(hasId ? item.id : item)
      return result
    }, [])
  }
  return obj.value && obj.value.hasOwnProperty('id') ? obj.value.id : obj.value
}